module.exports = __webpack_public_path__ + "img/home-visual-01.3a9ea843.jpg";